export const LEVELS = ["Bronze", "Silver", "Gold", "Platinum", "Diamond"];
export const BADGE_OPTIONS = ["Verified", "Gold", "Platinum", "VIP", "Top Investor", "Long Term"];
export const INVESTMENT_TYPES = ["Deposit", "Bonus", "Reinvestment", "Referral", "Adjustment"];
export const WITHDRAWAL_METHODS = ["UPI", "Cash"];
export const WITHDRAWAL_STATUSES = ["Pending", "Approved", "Rejected", "Completed"];
